'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { map, list } from 'react-immutable-proptypes';
import styled from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSerieSymbol = styled.div.withConfig({
  displayName: "FilterOverlapsModal__StyledSerieSymbol",
  componentId: "sc-1isy9ex-0"
})(["border-radius:50%;width:8px;height:8px;background-color:", ";"], ({
  backgroundColor
}) => backgroundColor);
class FilterOverlapsModal extends Component {
  constructor(...args) {
    super(...args);
    this.handleClick = point => {
      const {
        onConfirm,
        onReject
      } = this.props;
      onConfirm(point);
      onReject(); // Close the modal
    };
    this.renderOverlappingPoint = () => {
      const {
        raasSeriesMap,
        overlapPoints
      } = this.props;
      const data = overlapPoints.map(point => {
        const seriesId = point.get('seriesId');
        const serie = raasSeriesMap.get(seriesId);
        const name = serie.get('name');
        const color = serie.getIn(['style', 'color']);
        return {
          point,
          name,
          color
        };
      });
      const body = data.map(({
        point,
        name,
        color
      }, key) => {
        return /*#__PURE__*/_jsxs(Button, {
          truncate: false,
          use: "tertiary-light",
          onClick: () => this.handleClick(point),
          children: [/*#__PURE__*/_jsx(View, {
            paddingInlineEnd: "100",
            display: "inline-block",
            children: /*#__PURE__*/_jsx(StyledSerieSymbol, {
              backgroundColor: color
            })
          }), /*#__PURE__*/_jsx("span", {
            children: name
          })]
        }, key);
      }).toList();
      return /*#__PURE__*/_jsx(ButtonWrapper, {
        justify: "center",
        children: body
      });
    };
  }
  render() {
    const {
      onReject
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      use: "conversational",
      size: 'auto',
      width: '50%',
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onReject
      }), /*#__PURE__*/_jsx(DialogHeader, {
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(Text, {
          children: I18n.text('reporting-visualizations.click-event-messages.overlapping-points.header')
        })
      }), /*#__PURE__*/_jsx(DialogBody, {
        paddingBlockEnd: "800",
        children: /*#__PURE__*/_jsxs(View, {
          textAlign: "center",
          children: [/*#__PURE__*/_jsx("p", {
            children: I18n.text('reporting-visualizations.click-event-messages.overlapping-points.message')
          }), this.renderOverlappingPoint()]
        })
      })]
    });
  }
}
FilterOverlapsModal.propTypes = {
  originalRaasPoint: map.isRequired,
  originalChartPoint: PropTypes.object.isRequired,
  chartSeries: PropTypes.array.isRequired,
  raasSeriesMap: map.isRequired,
  overlapPoints: list.isRequired,
  onReject: PropTypes.func.isRequired
};
export default FilterOverlapsModal;